const en = {
  previewWarnings: {'GLOVO_EXPORT_LIMITATIONS': 'Individual quantity limits are not sent to Glovo; the attached SGR deposit is included in option prices.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Category images are not sent to Wolt. Catalog images are retained.'},
  credentialsSavedTitle: 'Integration saved',
  credentialsSavedSyncMenu: 'Your credentials and settings have been saved. Sync the menu from Menu management to complete setup.',
  credentialsSavedSyncMenuSchedule: 'Your credentials and settings have been saved. Sync the menu from Menu management, then sync the opening hours from Opening hours to complete setup.',
  locationsSectionHint: 'Choose where your menu comes from and where platform orders arrive.',
  credentialsSectionHint: 'Connection details used to identify your store on the platform.',
  'operations': 'Platform settings and actions',
  'orderSettings': 'Orders and availability',
  'orderSettingsHint': 'Configure incoming orders and monitor platform availability.',
  'integrationActive': 'Integration enabled',
  'scheduleTitle': 'Opening hours',
  'scheduleHint': 'Edit the weekly hours here, then sync this schedule to the platform.',
  'closedDay': 'Closed',
  'addInterval': 'Add interval',
  'saveBeforeActions': 'Save the integration to enable platform actions.',
  'notifications': 'Email notifications',
  'locations': 'Locations',
  'menuLocation': 'Menu location',
  'ordersLocation': 'Orders location',
  'menuHint': 'The catalog and prices used to publish your platform menu.',
  'ordersHint': 'Incoming platform orders will be created at this location.',
  'credentials': 'Platform credentials',
  'settings': 'Other settings',
  'role': 'Used for',
  'menu': 'Menu',
  'orders': 'Orders',
  'menu_orders': 'Menu + orders',
  'menuActions': 'Menu management',
  'menuActionsHint': 'Review your menu before publishing, or bring an existing platform menu into your catalog.',
  'connection': 'Platform connection',
  'connectionHint': 'Connect this location to Wolt or refresh its credentials.',
  'availability': 'Orders and opening hours',
  'availabilityHint': 'Control whether the platform accepts orders and update its opening hours.'
}
const ro = {
  previewWarnings: {'GLOVO_EXPORT_LIMITATIONS': 'Limitele individuale de cantitate nu sunt trimise către Glovo; garanția SGR atașată este inclusă în prețurile opțiunilor.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Imaginile categoriilor nu sunt trimise către Wolt. Imaginile din catalog sunt păstrate.'},
  credentialsSavedTitle: 'Integrare salvată',
  credentialsSavedSyncMenu: 'Datele de conectare și setările au fost salvate. Sincronizează meniul din secțiunea Gestionare meniu pentru a finaliza configurarea.',
  credentialsSavedSyncMenuSchedule: 'Datele de conectare și setările au fost salvate. Sincronizează meniul din secțiunea Gestionare meniu, apoi programul din secțiunea Program de funcționare pentru a finaliza configurarea.',
  locationsSectionHint: 'Alege sursa meniului și locația în care ajung comenzile de pe platformă.',
  credentialsSectionHint: 'Datele de conectare care identifică magazinul tău pe platformă.',
  'operations': 'Setări și acțiuni pe platformă',
  'orderSettings': 'Comenzi și disponibilitate',
  'orderSettingsHint': 'Configurează comenzile primite și monitorizează disponibilitatea pe platformă.',
  'integrationActive': 'Integrare activă',
  'scheduleTitle': 'Program de funcționare',
  'scheduleHint': 'Editează programul săptămânal, apoi sincronizează-l cu platforma.',
  'closedDay': 'Închis',
  'addInterval': 'Adaugă interval',
  'saveBeforeActions': 'Salvează integrarea pentru a activa acțiunile pe platformă.',
  'notifications': 'Notificări prin email',
  'locations': 'Locații',
  'menuLocation': 'Locație meniu',
  'ordersLocation': 'Locație comenzi',
  'menuHint': 'Catalogul și prețurile folosite pentru publicarea meniului pe platformă.',
  'ordersHint': 'Comenzile primite de pe platformă vor fi create în această locație.',
  'credentials': 'Date de conectare la platformă',
  'settings': 'Alte setări',
  'role': 'Utilizare',
  'menu': 'Meniu',
  'orders': 'Comenzi',
  'menu_orders': 'Meniu + comenzi',
  'menuActions': 'Gestionare meniu',
  'menuActionsHint': 'Verifică meniul înainte de publicare sau importă meniul platformei în catalog.',
  'connection': 'Conectare la platformă',
  'connectionHint': 'Conectează locația la Wolt sau actualizează datele de conectare.',
  'availability': 'Comenzi și program',
  'availabilityHint': 'Controlează acceptarea comenzilor pe platformă și actualizează programul.'
}
export default {
  en,
  ro,
  el: { ...en, previewWarnings: {'GLOVO_EXPORT_LIMITATIONS': 'Τα μεμονωμένα όρια ποσότητας δεν αποστέλλονται στο Glovo· η συνδεδεμένη εγγύηση SGR περιλαμβάνεται στις τιμές των επιλογών.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Οι εικόνες κατηγοριών δεν αποστέλλονται στο Wolt. Οι εικόνες του καταλόγου διατηρούνται.'} },
  nl: { ...en, previewWarnings: {'GLOVO_EXPORT_LIMITATIONS': 'Individuele hoeveelheidslimieten worden niet naar Glovo verzonden; het gekoppelde SGR-statiegeld is inbegrepen in de optieprijzen.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Categorieafbeeldingen worden niet naar Wolt verzonden. De afbeeldingen in de catalogus blijven behouden.'} },
  it: { ...en, previewWarnings: {'GLOVO_EXPORT_LIMITATIONS': 'I limiti di quantità individuali non vengono inviati a Glovo; il deposito SGR associato è incluso nei prezzi delle opzioni.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Le immagini delle categorie non vengono inviate a Wolt. Le immagini del catalogo vengono conservate.'} },
  de: { ...en, previewWarnings: {'GLOVO_EXPORT_LIMITATIONS': 'Individuelle Mengenlimits werden nicht an Glovo gesendet; das zugehörige SGR-Pfand ist in den Optionspreisen enthalten.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Kategoriebilder werden nicht an Wolt gesendet. Die Bilder im Katalog bleiben erhalten.'} }
}




// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Integrations/marketplaceLabels.js